import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Header from '../components/Header/Header';
import Counterparties from '../counterparties/Counterparties/Counterparties';
import Facilities from '../facility/Facilities/Facilities';
import Facility from '../facility/Facility/Facility';
import Meters from '../meters/Meters/Meters';
import useReceiptTypes from '../queries/useReceiptTypes';
import useRoomsStates from '../queries/useRoomsStates';
import useRoomsTypes from '../queries/useRoomsTypes';
import Room from '../room/Room/Room';
import styles from './OfficesMain.module.scss';

const OfficesMain = () => {
  useReceiptTypes();
  useRoomsStates();
  useRoomsTypes();

  return (
    <div className={styles.root}>
      <Header />
      <Breadcrumbs />
      <Switch>
        <Route path={'/Offices/facilities/:facilityId/rooms/:roomId/:roomTab?'}>
          <Room />
        </Route>
        <Route path={'/Offices/facilities/:facilityId/:facilityTab?'}>
          <Facility />
        </Route>
        <Route exact path={'/Offices/facilities'}>
          <Facilities />
        </Route>
        <Route path={'/Offices/counterparties'}>
          <Counterparties />
        </Route>
        <Route path={'/Offices/meters'}>
          <Meters />
        </Route>
        <Redirect exact from="/Offices" to="/Offices/facilities" />
      </Switch>
    </div>
  );
};

export default OfficesMain;
